export default __webpack_public_path__ + "static/media/rocket_anim_82.78c39b19.png";